/** @format */

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  share: {},
  hide: true,
  loading: false,
  done: false,
  error: ''
});

export default function removeShareReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'REMOVE_SHARE_MODAL_SHOW': {
      return state.set('hide', false).set('share', action.payload);
    }
    case 'REMOVE_SHARE_MODAL_HIDE': {
      return INITIAL_STATE;
    }
    case 'REMOVE_SHARE_START': {
      return state.set('loading', true).set('error', '');
    }
    case 'REMOVE_SHARE_FAIL': {
      return state.set('loading', false).set('error', action.payload);
    }
    case 'REMOVE_SHARE_DONE': {
      return state.set('loading', false).set('done', true);
    }
    default: {
      return state;
    }
  }
}
